export default {
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    UPDATE_NEW_PASSWORD_PENDING: 'UPDATE_NEW_PASSWORD_PENDING',
    UPDATE_NEW_PASSWORD_SUCCESS: 'UPDATE_NEW_PASSWORD_SUCCESS',
    UPDATE_NEW_PASSWORD_FAILURE: 'UPDATE_NEW_PASSWORD_FAILURE',
    UPDATE_NEW_EMAIL_PENDING: 'UPDATE_NEW_EMAIL_PENDING',
    UPDATE_NEW_EMAIL_SUCCESS: 'UPDATE_NEW_EMAIL_SUCCESS',
    UPDATE_NEW_EMAIL_FAILURE: 'UPDATE_NEW_EMAIL_FAILURE',
    UPDATE_EXPIRED_PASSWORD_PENDING: 'UPDATE_EXPIRED_PASSWORD_PENDING',
    UPDATE_EXPIRED_PASSWORD_SUCCESS: 'UPDATE_EXPIRED_PASSWORD_SUCCESS',
    UPDATE_EXPIRED_PASSWORD_FAILURE: 'UPDATE_EXPIRED_PASSWORD_FAILURE'
}
